/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ContentList from './index';
import {
  getGlobalInteractives,
  getSharedInteractives,
  getUserInteractives,
} from '../../middleware/api';
import { initializeReactGA } from '../../middleware/googleAnalytics';
import { ParentDataInterface } from '../../redux/parentDataSlice';

type InteractivesType = 'global' | 'shared' | 'user';

interface Props extends RouteComponentProps {
  type: InteractivesType;
}

const InteractivesComponent: React.FC<Props> = (props) => {
  const [interactives, setInteractives] = useState([]);
  const [fetching, setFetching] = useState(true);

  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  useEffect(() => {
    if (!dataFromParent) {
      return props.history.push('/401');
    }

    const fetchData = async () => {
      try {
        initializeReactGA(props.location.pathname, dataFromParent);
        setFetching(true);
        let interactiveLists: any = {};
        switch (props.type) {
          case 'global':
            interactiveLists = await getGlobalInteractives(
              dataFromParent.userId,
              dataFromParent.orgId,
            );
            break;
          case 'shared':
            interactiveLists = await getSharedInteractives({
              orgid: dataFromParent.orgId,
              accountid: dataFromParent.sharedAccountId,
              userid: dataFromParent.userId,
            });
            break;
          case 'user':
            if (!dataFromParent.userId) return;
            interactiveLists = await getUserInteractives(
              dataFromParent.userId,
              dataFromParent.orgId,
            );
            break;
          default:
            throw new Error('Invalid interactives type');
        }
        setFetching(false);
        switch (props.type) {
          case 'global':
            setInteractives(interactiveLists.globalInteractives ?? []);
            break;
          case 'shared':
            setInteractives(interactiveLists.sharedInteractives ?? []);
            break;
          case 'user':
            setInteractives(interactiveLists.userInteractives ?? []);
            break;
        }
      } catch (error) {
        console.log('error in fetching Interactive lists', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFromParent, props, props.type]);

  return <ContentList fetching={fetching} interactiveLists={interactives} {...props} />;
};

export const GlobalInteractives = (props: any) => (
  <InteractivesComponent {...props} type='global' />
);
export const SharedInteractives = (props: any) => (
  <InteractivesComponent {...props} type='shared' />
);
export const UserInteractives = (props: any) => <InteractivesComponent {...props} type='user' />;
